import sheetdb from 'sheetdb-node';
import { useState } from 'react';
import bannerImg from './bannerImage.jpeg';
import { Button, Modal, 
    ModalHeader, 
    ModalBody, 
    ModalFooter, Form, FormGroup, Input, Label, Col, Row, 
    Container} from 'reactstrap';
import './banner.css';
import Loading from './loading';
const Banner = () => {
  var config = {
    address: 'lmrht3p7ssu0r',
  };
  
  // Create new client
  var client = sheetdb(config);
  
  const [formToggle, setFormToggle] = useState(false)
  const toggle = () => setFormToggle(!formToggle);
  const [successDiag, setSuccessDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const [parentName, setParentName] = useState("")
  const [studentName, setStudentName] = useState("")
  const [number, setNumber] = useState("")
  const [email, setEmail] = useState("")
  

  const handleChange = (event) => {
    if(event.target.name == "parentName"){
      setParentName(event.target.value)
    }
    if(event.target.name == "email"){
      setEmail(event.target.value)
    }
    if(event.target.name == "parentPhone"){
      setNumber(event.target.value)
    }
    if(event.target.name == "studentName"){
      setStudentName(event.target.value)
    }
  }

  const handleSubmit = () => {
    try{
      setLoading(true)
      client.create({ 
        ParentName: parentName, 
        TeenName: studentName,
        TeenAge: 10,
        ParentEmail: email,
        ParentPhone: number
      }, "Students").then(()=>{
      toggle();
      setLoading(false)
      setSuccessDialog(true)
      })
    }
    catch(ex){
      setLoading(false)
      alert(ex.data)
    }
  }




    
    return(
        <>

        {loading == true ? <Loading/> : <span></span>}
        <div className="bannerDiv">
        <Modal style={{border:'none'}}  isOpen={successDiag} toggle={()=>{setSuccessDialog(false)}}>
        <ModalHeader className='text-center' style={{border:'none'}} toggle={()=>{setSuccessDialog(false)}}><h3 className='text-success'>Congratulations!</h3></ModalHeader>
        <ModalBody>
        <Container>
          <Row>
            <Col sm={12} lg={12} md={12}>

            </Col>
            <Col className='text-center mb-5' lg={12} md={12} sm={12}>
              Thanks for signing up! I will be reaching out through text shortly. Talk soon :)
            </Col>
          </Row>
        </Container>
        </ModalBody>
      </Modal>





             <Modal style={{border:'none'}}  isOpen={formToggle} toggle={toggle}>
        <ModalHeader style={{border:'none'}} toggle={toggle}>One Step Closer to a Productive Summer</ModalHeader>
        <ModalBody>
        <Form>
  <Row>
  <Col md={12}>
      <FormGroup>
        <Label for="parentName">
          Parent Name
        </Label>
        <Input
          onChange={handleChange}
          id="parentName"
          name="parentName"
          placeholder="Name of Parent"
          type="text"
        />
      </FormGroup>
    </Col>
    <Col md={12}>
      <FormGroup>
        <Label for="studentName">
        Student Name
        </Label>
        <Input
        onChange={handleChange}
          id="studentName"
          name="studentName"
          placeholder="Name of Student"
          type="text"
        />
      </FormGroup>
    </Col>
    <Col md={12}>
      <FormGroup>
        <Label for="email">
          Parent Email
        </Label>
        <Input
        onChange={handleChange}
          id="email"
          name="email"
          placeholder="Email of Parent"
          type="email"
        />
      </FormGroup>
    </Col>
    <Col md={12}>
      <FormGroup>
        <Label for="parentPhone">
        Parent Phone
        </Label>
        <Input
        onChange={handleChange}
          id="parentPhone"
          name="parentPhone"
          placeholder="Phone number of Parent"
          type="text"
        />
      </FormGroup>
    </Col>
  </Row>
  
  
  <Row>
    <Col md={6}>
      
    </Col>
    <Col md={4}>
      
    </Col>
    <Col md={2}>
      
    </Col>
  </Row>
</Form>
        </ModalBody>
        <ModalFooter style={{border:'none'}} >
          <Button color="primary" onClick={handleSubmit}>
            Sign Up
          </Button>
        </ModalFooter>
      </Modal>
            <img src={bannerImg} />
            <div className='centered'>
                <div className='content'>
                  <br/>
                    <h3 style={{fontWeight:'bolder'}}>Summer Fun is Here</h3>
                    <h1 className='build' style={{fontWeight:'bolder', color:'#ffc107'}}>Build A PC Workshop</h1>
                    <h3 style={{fontWeight:'bolder'}}>Learn - Build - Take Home</h3>
                    <br/>
                    <h5 style={{color:'red'}}><s>$249</s></h5>
                    <h4 style={{fontWeight:'bold'}}>$199 ONLY!</h4>
                    <Button style={{fontWeight:'bold'}} onClick={toggle} color="warning">Enroll Now</Button>
                </div>
                
            </div>
        </div>


        {/* <Row>
    <Col className='bg-warning text-center' md={6} lg={6} sm={12} style={{position:'relative'}}>
      <div className='build'>
      <h1 style={{fontWeight:'bolder', fontSize:'70px', color:'black', transform:'rotate(-3deg)'}}>BUILD A PC WORKSHOP</h1>
      </div>
      
    </Col>
    <Col style={{overflow:'hidden'}} md={6} lg={6} sm={12}>
      <img src={bannerImg} width='100%'/> 
    </Col>
  </Row> */}
        </>
        
    )
}

export default Banner;